import * as React from "react"

import Layout from "../components/layout"
import Head from '../components/head'

const ImprintPage = () => {
  return (
    <Layout>
      <div>
        <main>
          <Head title="Impressum" />

          <div>
            <h2 className="mb-4 text-2xl font-bold">Angaben gemäß § 5 TMG</h2>
            <p>
              Gesina Seldte<br />
              Wangenheimstraße 27<br />
              14193 Berlin
            </p>
            <h2 className="mt-8 mb-4 text-2xl font-bold">Kontakt</h2>
            <p>
              Telefon: <>017&#54;&#32;&#53;&#52; 48&#32;47 3&#48;</><br />
              E-Mail: <>ges&#105;na&#45;se&#108;&#100;te&#64;t-online&#46;d&#101;</><br />
              Webseite: seldte.de
            </p>
            <h2 className="mt-8 mb-4 text-2xl font-bold">Fotografie</h2>
            <p>Matthias Seldte, Cornelia Schiffers</p>
            <h2 className="mt-8 mb-4 text-2xl font-bold">Design, Programmierung, Beratung</h2>
            <p>Stephan Schneider, Cornelia Schiffers</p>
          </div>
        </main>
      </div>
    </Layout>
  )
}

export default ImprintPage
